import { addError } from './error';
import api from '../../helpers/ApiClient';

export const REQUEST_ORDER_STATUS = 'REQUEST_ORDER_STATUS';
export const RECEIVE_ORDER_STATUS = 'RECEIVE_ORDER_STATUS';
export const FAIL_ORDER_STATUS = 'FAIL_ORDER_STATUS';

function receiveOrderStatus(json) { 
  return {
    type: RECEIVE_ORDER_STATUS,
    payload: {
      detail: json
    }
  };
}

function requestStatus(ticketId) {
  return {
    type: REQUEST_ORDER_STATUS,
    payload: {
      ticketId,
    }
  };
}

function failOrderStatus() {
  return {
    type: FAIL_ORDER_STATUS,
    payload: {}
  };
}

function shouldFetchStatus(state) {

  const results = state.status;
  if (results && results.loading) {
    return false;
  } else {
    return true;
  }
}

function fetchStatusFromApi(ticketId, orderId) {
  return dispatch => {
    dispatch(requestStatus(ticketId));
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }

    let apiUrl = `/api/status/${ticketId}`;
    if(orderId){
      apiUrl += `/${orderId}`
    }
    return api(apiUrl, options)
      .then(json => {
        // console.log('get status result', json)
        dispatch(receiveOrderStatus(json))
      })
      .catch(err => {

        dispatch(failOrderStatus(ticketId));
        dispatch(addError(err));
      });
  };
}

export function fetchStatus(ticketId, orderId) {


  return (dispatch, getState) => {
    if (shouldFetchStatus(getState())) {
      return dispatch(fetchStatusFromApi(ticketId, orderId));
    }
  };
}